import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import sortBy from 'lodash/sortBy';

import { fetchFAQs } from '../store/reducer/faqSlice';

export const useFAQ = () => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state?.faqs);

  const [faqList, setFaqList] = useState([]);

  useEffect(() => {
    if (!loading && !Object.keys(data)?.length) {
      dispatch(fetchFAQs());
    }
  }, []);

  useEffect(() => {
    setFaqList([...(sortBy(data?.data?.faqList, 'priorityIndex') ?? [])]);
  }, [data?.data?.faqList]);

  return {
    loading,
    faqList,
  };
};
